var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.video_url && _vm.video_component_type)?_c(_vm.video_component_type,{tag:"component",staticClass:"embed_file",attrs:{"video_url":_vm.video_url}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }